import { MenuItem } from "@blueprintjs/core";
import { ItemPredicate, ItemRenderer, Select } from "@blueprintjs/select";
import * as React from "react";
import { IIcmsClassificacao } from "../../model";
import { formatCnpj } from "../../utils";

export const IcmsClassificacaoSelect = Select.ofType<IIcmsClassificacao>();

export const filterIcmsClassificacao: ItemPredicate<IIcmsClassificacao> = (
  query,
  clas,
) => {
  return clas.nome.toLowerCase().indexOf(query.toLowerCase()) >= 0;
};

export const renderIcmsClassificacao: ItemRenderer<IIcmsClassificacao> = (
  clas,
  { handleClick, modifiers },
) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }
  return (
    <MenuItem
      active={modifiers.active}
      key={clas.id}
      text={clas.nome}
      onClick={handleClick}
    />
  );
};
